import _ from 'lodash';
import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {getCardGroups} from '../../../store/data/dataSelectors';
import {CardGroupPopover} from './cardGroupPopover';

/*
 * Props.
 */

interface CardGroupPopoverContainerProps {
  cardGroupIds: ReadonlyArray<number>;
}

/*
 * Selectors.
 */

function getCardGroupIds(_state: AppState, props: CardGroupPopoverContainerProps) {
  return props.cardGroupIds;
}

function makeGetCardGroups() {
  return createSelector([getCardGroupIds, getCardGroups], (cardGroupIds, cardGroups) =>
    _(cardGroupIds)
      .map((cardGroupId) => cardGroups[cardGroupId])
      .compact()
      .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CardGroupPopoverContainerProps>()(() => ({
  cardGroups: makeGetCardGroups(),
}));

export const CardGroupPopoverContainer = connect(mapStateToProps)(CardGroupPopover);
